export const ACTOR_TYPES = [
  "army",
  "character",
  "familiar",
  "hazard",
  "loot",
  "npc",
  "party",
  "vehicle"
];

/* -------------------------------------------- */

export const PROPERTIES = [
  "activeEffect.deleted",
  "activeEffect.disabled",
  "actor.inCombat",
  "actor.itemCreated",
  "actor.itemDeleted",
  "actor.name",
  "actor.system.abilities.cha.mod",
  "actor.system.abilities.con.mod",
  "actor.system.abilities.dex.mod",
  "actor.system.abilities.int.mod",
  "actor.system.abilities.str.mod",
  "actor.system.abilities.wis.mod",
  "actor.system.attributes.ac.details",
  "actor.system.attributes.ac.value",
  "actor.system.attributes.allSaves.value",
  "actor.system.attributes.hp.details",
  "actor.system.attributes.hp.max",
  "actor.system.attributes.hp.temp",
  "actor.system.attributes.hp.value",
  "actor.system.attributes.speed.details",
  "actor.system.attributes.speed.value",
  "actor.system.details.age.value",
  "actor.system.details.biography.attitude",
  "actor.system.details.biography.birthPlace",
  "actor.system.details.biography.catchphrases",
  "actor.system.details.biography.dislikes",
  "actor.system.details.biography.likes",
  "actor.system.details.biography.visibility.appearance",
  "actor.system.details.biography.visibility.backstory",
  "actor.system.details.biography.visibility.campaign",
  "actor.system.details.biography.visibility.personality",
  "actor.system.details.blurb",
  "actor.system.details.ethnicity.value",
  "actor.system.details.gender.value",
  "actor.system.details.height.value",
  "actor.system.details.keyability.value",
  "actor.system.details.languages.details",
  "actor.system.details.level.value",
  "actor.system.details.nationality.value",
  "actor.system.details.publication.authors",
  "actor.system.details.publication.license",
  "actor.system.details.publication.remaster",
  "actor.system.details.publication.title",
  "actor.system.details.weight.value",
  "actor.system.details.xp.max",
  "actor.system.details.xp.min",
  "actor.system.details.xp.value",
  "actor.system.initiative.statistic",
  "actor.system.perception.details",
  "actor.system.perception.mod",
  "actor.system.perception.rank",
  "actor.system.perception.vision",
  "actor.system.proficiencies.attacks.advanced.rank",
  "actor.system.proficiencies.attacks.martial.rank",
  "actor.system.proficiencies.attacks.simple.rank",
  "actor.system.proficiencies.attacks.unarmed.rank",
  "actor.system.proficiencies.defenses.heavy.rank",
  "actor.system.proficiencies.defenses.light.rank",
  "actor.system.proficiencies.defenses.medium.rank",
  "actor.system.proficiencies.defenses.unarmored.rank",
  "actor.system.pfs.characterNumber",
  "actor.system.pfs.currentFaction",
  "actor.system.pfs.levelBump",
  "actor.system.pfs.playerNumber",
  "actor.system.pfs.reputation.EA",
  "actor.system.pfs.reputation.GA",
  "actor.system.pfs.reputation.HH",
  "actor.system.pfs.reputation.RO",
  "actor.system.pfs.reputation.VS",
  "actor.system.pfs.reputation.VW",
  "actor.system.pfs.school",
  "actor.system.resources.heroPoints.max",
  "actor.system.resources.heroPoints.value",
  "actor.system.saves.fortitude.rank",
  "actor.system.saves.fortitude.saveDetail",
  "actor.system.saves.fortitude.value",
  "actor.system.saves.reflex.rank",
  "actor.system.saves.reflex.saveDetail",
  "actor.system.saves.reflex.value",
  "actor.system.saves.will.rank",
  "actor.system.saves.will.saveDetail",
  "actor.system.saves.will.value",
  "actor.system.skills.acrobatics.rank",
  "actor.system.skills.arcana.rank",
  "actor.system.skills.athletics.rank",
  "actor.system.skills.crafting.rank",
  "actor.system.skills.deception.rank",
  "actor.system.skills.diplomacy.rank",
  "actor.system.skills.intimidation.rank",
  "actor.system.skills.medicine.rank",
  "actor.system.skills.nature.rank",
  "actor.system.skills.occultism.rank",
  "actor.system.skills.performance.rank",
  "actor.system.skills.religion.rank",
  "actor.system.skills.society.rank",
  "actor.system.skills.stealth.rank",
  "actor.system.skills.survival.rank",
  "actor.system.skills.thievery.rank",
  "actor.system.traits.rarity",
  "actor.system.traits.size.value",
  "item.name",
  "item.system.ability.value",
  "item.system.acBonus",
  "item.system.bonus.value",
  "item.system.bulk.capacity",
  "item.system.bulk.heldOrStowed",
  "item.system.bulk.ignored",
  "item.system.bulk.value",
  "item.system.capacity",
  "item.system.category",
  "item.system.checkPenalty",
  "item.system.collapsed",
  "item.system.containerId",
  "item.system.damage.damageType",
  "item.system.damage.dice",
  "item.system.damage.die",
  "item.system.dexCap",
  "item.system.equipped.carryType",
  "item.system.equipped.handsHeld",
  "item.system.equipped.invested",
  "item.system.hardness",
  "item.system.hp.max",
  "item.system.hp.value",
  "item.system.identification.status",
  "item.system.level.value",
  "item.system.material.grade",
  "item.system.material.type",
  "item.system.mod.value",
  "item.system.prepared.value",
  "item.system.proficiency.value",
  "item.system.proficient.value",
  "item.system.quantity",
  "item.system.reload.value",
  "item.system.runes.potency",
  "item.system.runes.reinforcing",
  "item.system.runes.resilient",
  "item.system.runes.striking",
  "item.system.size",
  "item.system.slots.slot0.max",
  "item.system.slots.slot0.value",
  "item.system.slots.slot1.max",
  "item.system.slots.slot1.value",
  "item.system.slots.slot2.max",
  "item.system.slots.slot2.value",
  "item.system.slots.slot3.max",
  "item.system.slots.slot3.value",
  "item.system.slots.slot4.max",
  "item.system.slots.slot4.value",
  "item.system.slots.slot5.max",
  "item.system.slots.slot5.value",
  "item.system.slots.slot6.max",
  "item.system.slots.slot6.value",
  "item.system.slots.slot7.max",
  "item.system.slots.slot7.value",
  "item.system.slots.slot8.max",
  "item.system.slots.slot8.value",
  "item.system.slots.slot9.max",
  "item.system.slots.slot9.value",
  "item.system.slots.slot10.max",
  "item.system.slots.slot10.value",
  "item.system.slots.slot11.max",
  "item.system.slots.slot11.value",
  "item.system.speedPenalty",
  "item.system.spelldc.dc",
  "item.system.spelldc.value",
  "item.system.splashDamage.value",
  "item.system.strength",
  "item.system.stowing",
  "item.system.tradition.value",
  "item.system.usage.value",
  "item.system.uses.autoDestroy",
  "item.system.uses.max",
  "item.system.uses.value",
  "token.disposition",
  "token.elevation",
  "token.name",
  "token.rotation",
  "token.sight.angle",
  "token.sight.attenuation",
  "token.sight.brightness",
  "token.sight.color",
  "token.sight.contrast",
  "token.sight.enabled",
  "token.sight.range",
  "token.sight.saturation",
  "token.sight.visionMode"
];

/* -------------------------------------------- */

export const DERIVED_PROPERTIES = [
  "actor.system.abilities.cha.mod",
  "actor.system.abilities.con.mod",
  "actor.system.abilities.dex.mod",
  "actor.system.abilities.int.mod",
  "actor.system.abilities.str.mod",
  "actor.system.abilities.wis.mod",
  "actor.system.attributes.ac.value",
  "actor.system.attributes.hp.max",
  "actor.system.attributes.speed.value"
];
